<template>
    <vue-scroll class="login-page align-vertical">
        <div class="form-wrapper align-vertical-middle">
            <div class="form-box card-base card-shadow--extraLarge">
                <img class="image-logo" :src="logo" alt="logo" />

                <el-form @submit.native.prevent="login">
                    <el-form-item :class="form.state('username')">
                        <el-input
                            @keydown.native.enter="login()"
                            placeholder="Email or Username"
                            v-model="form.username"
                        />
                        <form-feedback :form="form" field="username" />
                    </el-form-item>
                    <el-form-item :class="form.state('password')">
                        <el-input
                            @keydown.native.enter="login()"
                            placeholder="Password"
                            show-password
                            type="password"
                            v-model="form.password"
                        />
                        <form-feedback :form="form" field="password" />
                    </el-form-item>

                    <div class="flex">
                        <div class="box grow">
                            <el-checkbox v-model="form.remember"
                                >Remember Me</el-checkbox
                            >
                        </div>
                        <div class="box grow text-right">
                            <router-link :to="{ name: 'ForgotPassword' }"
                                >Forgot Password?</router-link
                            >
                        </div>
                    </div>

                    <div class="flex text-center center pt-30 pb-10">
                        <el-button
                            :loading="form.busy"
                            plain
                            size="small"
                            @click.prevent="login"
                            class="login-btn tada animated"
                        >
                            LOGIN
                        </el-button>
                    </div>
                    <div class="help">
                        For help email
                        <a href="mailto:support@corwindesign.com"
                            >support@corwindesign.com</a
                        >
                    </div>
                </el-form>
            </div>
        </div>
    </vue-scroll>
</template>

<script>
import * as Getters from "@/store/constants/getters";
import CustomNotificationUtils from "@/utils/custom-notification";

export default {
    name: "Login",
    data() {
        return {
            form: new Form({
                username: "",
                password: "",
                remember: true,
            }),
        };
    },
    computed: {
        logo() {
            return this.$store.getters[Getters.GET_LOGO];
        },
    },
    methods: {
        login() {
            App.post("/login", this.form).then((response) => {
                this.$store.commit("setLogin");
                CustomNotificationUtils.setNotified(false);
                window.location = `/home?redirect=${encodeURIComponent(
                    response.data.redirect
                )}`;
            });
        },
    },
};
</script>

<style lang="scss">
@import "../../../../assets/scss/variables";

.login-page {
    background: $corwin-green;
    margin-left: -30px;
    margin-right: -30px;

    .form-wrapper {
        width: 100%;
    }

    .form-box {
        width: 100%;
        max-width: 340px;
        padding: 30px;
        box-sizing: border-box;
        margin: 20px auto;

        a {
            font-size: 14px;
            color: $text-color-accent;
            text-decoration: none;
            font-weight: 500;
        }

        .image-logo {
            width: 190px;
            margin: 0 auto 30px;
            display: block;
        }

        .login-btn,
        .social-btn {
            width: 160px;

            &.google {
                margin-bottom: 10px;
                background-color: #d73d32;
                color: white;

                &:hover {
                    border-color: #d73d32;
                }
            }
            &.facebook {
                background-color: #3f5c9a;
                color: white;

                &:hover {
                    border-color: #3f5c9a;
                }
            }
        }

        .signin-box {
            font-size: 14px;
        }
    }

    .help {
        text-align: center;
        font-size: 11pt;
    }
}

@media (max-width: 768px) {
    .layout-container .container .view.login-page {
        margin-left: -5px;
        margin-right: -5px;
        max-width: calc(100% + 10px);
    }
}
</style>
